@layer reset, default;

@layer reset {
  :host {
    slot {
      display: initial;
    }
  }
}

@layer default {
  :host {
    clip-path: inset(100%);
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
}
